import { Button, message } from "antd";
import { useState } from "react";
import { syncSingleKylasDeal } from "../../apis/kylas_sync_dashboard.api";

interface Props {
  estimateId?: number;
  leadId?: string | null;
  size?: "small" | "middle" | "large";
}

export default function KylasSyncButton({ estimateId, leadId, size = "small" }: Props) {
  const [loading, setLoading] = useState(false);

  const handleSync = async () => {
    setLoading(true);
    try {
      const res = await syncSingleKylasDeal({ estimate_id: estimateId, lead_id: leadId });
      if (res?.success) {
        if (res.deal_id) {
          message.success(
            <span>
              {res.message || "Deal synced to Kylas"}{" "}
              <a
                href={`https://app.kylas.io/sales/deals/details/${res.deal_id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                View deal ↗
              </a>
            </span>,
            8
          );
        } else {
          message.success(res.message || "Deal synced to Kylas");
        }
      } else {
        message.error(res?.message || "Failed to sync deal to Kylas");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      size={size}
      loading={loading}
      onClick={handleSync}
      title="Sync this deal to Kylas if it's missing"
    >
      Kylas Sync
    </Button>
  );
}
